import { UnleashClient } from 'unleash-proxy-client';

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();

  if (!config.public.unleashToken) return;

  const unleash = new UnleashClient({
    url: 'https://eu.app.unleash-hosted.com/eubb1003/api/frontend/',
    clientKey: config.public.unleashToken,
    appName: 'iris',
  });

  await unleash.start();
  nuxtApp.provide('unleash', unleash);
});
